import type { AddPhotosType } from './contexts/PhotoUploadContext';
import { ProcessQueue } from './processQueue';

export const queue = new ProcessQueue<AddPhotosType>();
